import type {MouseEventHandler, ReactNode} from 'react'

interface ExternalLinkProps {
    href: string
    children: ReactNode
    onClick?: MouseEventHandler<HTMLAnchorElement>
    'data-testid'?: string
    'aria-label'?: string
}

/**
 * Anchor link to an external URL. Opens in a new tab with `rel="noopener
 * noreferrer"` and styled with the primary link vocabulary. Use for documentation
 * links and other targets that live outside the SPA — for internal routing use
 * {@link TextLink} (generic styled router link) or {@link EntityLink} (renders
 * an EntityLink value with icon and badge).
 */
export function ExternalLink({
    href,
    children,
    onClick,
    'data-testid': testId,
    'aria-label': ariaLabel,
}: ExternalLinkProps) {
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
            onClick={onClick}
            data-testid={testId}
            aria-label={ariaLabel}
        >
            {children}
        </a>
    )
}
